import { AnimatePresence, motion } from 'framer-motion';
import { WifiOff } from 'lucide-react';

import { useOnlineStatus } from '../../lib/hooks/useOnlineStatus';

/** Shown app-wide when offline (CP-P4-T02/DEC-0038) — the client may still
 * be viewing a previously-cached report/journey via TanStack Query's
 * persisted cache, so this tells them the data may not be current. */
export function OfflineBanner(): JSX.Element | null {
  const online = useOnlineStatus();

  return (
    <AnimatePresence>
      {!online && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: 'auto', opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="overflow-hidden"
        >
          <div className="flex items-center justify-center gap-2 bg-warning/15 text-warning text-xs font-medium px-4 py-2">
            <WifiOff className="w-3.5 h-3.5 shrink-0" />
            You&rsquo;re offline — showing your last saved report and progress.
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
